import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class ScrollTabsController extends Controller {
  static targets = [
    'panel',
    'link'
  ];

  initialize() {
    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      {
        root: null,
        threshold: 0.3
      }
    );
  }

  connect() {
    this.panelTargets.forEach(panel => this.observer.observe(panel));
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        const link = this.linkTargets.find(link =>
          link.getAttribute('href') === `#${id}`
        );

        if (link) this.activateLink(link);
      }
    });
  }

  activateLink(link) {
    this.linkTargets.forEach(link => link.classList.remove('active'));
    link.classList.add('active');
    const tab = new bootstrap.Tab(link);
    tab.show();
  }
}
